import { useState } from "react";
import ModalCloseX from "../common/ModalCloseX";

export default function StaffCredentialModal({ credential, onClose }) {
  const [copyStatus, setCopyStatus] = useState("");
  if (!credential) {
    return null;
  }

  const lines = [
    `Salon ID: ${credential.salon_id}`,
    `Username: ${credential.username}`,
    credential.temp_password
      ? `Temporary password: ${credential.temp_password}`
      : null,
  ].filter(Boolean);

  const payloadText = lines.join("\n");

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(payloadText);
      } else if (typeof document !== "undefined") {
        const textarea = document.createElement("textarea");
        textarea.value = payloadText;
        textarea.style.position = "fixed";
        textarea.style.left = "-10000px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopyStatus("Copied!");
    } catch (err) {
      console.error("Failed to copy staff credentials", err);
      setCopyStatus("Copy failed");
    } finally {
      setTimeout(() => setCopyStatus(""), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70 px-3">
      <div className="relative w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-xl overflow-hidden">
        <div className="flex items-center justify-between bg-rose-500 px-5 py-4">
          <h2 className="text-lg font-semibold text-white">
            Login details for {credential.display_name || credential.username}
          </h2>
          <ModalCloseX onClick={onClose} />
        </div>
        <div className="p-6">
          <p className="text-sm text-slate-600 mb-3">
            Share these credentials securely with the new staff member.
          </p>
          <div className="space-y-2 text-sm text-slate-800">
            <p>
              <span className="font-semibold">Salon ID:</span> {credential.salon_id}
            </p>
            <p>
              <span className="font-semibold">Username:</span> {credential.username}
            </p>
            {credential.temp_password ? (
              <p>
                <span className="font-semibold">Temporary password:</span>{" "}
                {credential.temp_password}
              </p>
            ) : (
              <p className="text-slate-500">
                No temporary password generated; existing credentials remain unchanged.
              </p>
            )}
          </div>
          {credential.must_change_password && (
            <p className="mt-4 text-xs uppercase tracking-wide text-rose-600">
              They must change password on first login.
            </p>
          )}
          <div className="mt-4 flex items-center gap-3">
            <button
              type="button"
              onClick={handleCopy}
              className="rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Copy login details
            </button>
            {copyStatus && (
              <span className="text-sm text-slate-600">{copyStatus}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


